import envfile from 'envfile';

export const PATH = '/etc/pooliot-client/config';

export default (() => {
  try {
    return envfile.parseFileSync(PATH);
  } catch (e) {
    return {};
  }
})();
